import React from "react";
import _ from "lodash";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  GoHomeButton,
  InfoSection,
  NotHomeServicePanel,
  withLayout,
} from "../../components";
import { getNavigationSettings } from "../../store/shared/navigationSettings.selectors";
import { SettingsNavBar } from "./settingsNavBar/SettingsNavBar";
import { MobileSettingsNavBar } from "./settingsNavBar/MobileSettingsNavBar";
import { Desktop, NotMobile, TabletMobile } from "../../common/Responsive";
import { AccountTab, BlockPageTab, DevicesTab, UrlFiltersTab } from "./tabs";

import "./SettingsPage.scss";

const TABS_CONTENT = {
  account: <AccountTab />,
  lists: <UrlFiltersTab />,
  block: <BlockPageTab />,
  devices: <DevicesTab />,
};

const SettingsPageComponent = () => {
  const tabs = useSelector(getNavigationSettings);

  return (
    <div className="settings-page">
      <InfoSection>
        <NotMobile>
          <GoHomeButton />
        </NotMobile>
        <NotHomeServicePanel />
      </InfoSection>
      <div className="settings-page__content">
        <Desktop>
          <div className="settings-page__sidebar">
            <div className="settings-page__sidebar-container">
              <SettingsNavBar tabs={tabs} />
            </div>
          </div>
        </Desktop>
        <TabletMobile>
          <MobileSettingsNavBar tabs={tabs} />
        </TabletMobile>
        <div className="settings-page__tabs-content">
          <div className="settings-page__tabs-content-container">
            <Routes>
              {_.map(tabs, ({ id, route, param }) => (
                <Route key={id} path={route} element={TABS_CONTENT[id]}>
                  {!_.isUndefined(param) && (
                    <Route path={param} element={TABS_CONTENT[id]} />
                  )}
                </Route>
              ))}
              <Route path="*" element={<Navigate to={tabs[0].route} />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SettingsPage = withLayout()(SettingsPageComponent);
